import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { getCleanupDatabaseData, selectCleanupDatabaseData, selectIsLoading, selectError } from '../feature';

export const useGetCleanupDatabaseData = () => {
  const dispatch = useAppDispatch();
  const cleanupDatabaseData = useAppState(selectCleanupDatabaseData);
  const isLoadingCleanupData = useAppState(selectIsLoading);
  const error = useAppState(selectError);

  useEffect(() => {
    dispatch(getCleanupDatabaseData());
  }, [dispatch]);

  return { cleanupDatabaseData, isLoadingCleanupData, error };
};
